import Background from 'src/assets/img/message/detail/bg-page.png'

import IconSora from 'src/assets/img/menu/icon_sora.png'
import IconMinato from 'src/assets/img/menu/icon_minato.png'
import IconRen from 'src/assets/img/menu/icon_ren.png'
import IconSho from 'src/assets/img/menu/icon_sho.png'
import IconSyun from 'src/assets/img/menu/icon_syun.png'
import IconKei from 'src/assets/img/menu/icon_kei.png'
import IconSakura from 'src/assets/img/menu/icon_sakura.png'
import IconJin from 'src/assets/img/menu/icon_jin.png'
import IconItsuki from 'src/assets/img/menu/icon_itsuki.png'
import IconNagi from 'src/assets/img/menu/icon_nagi.png'
import IconRei from 'src/assets/img/menu/icon_rei.png'
import IconRitsu from 'src/assets/img/menu/icon_ritsu.png'
import IconRin from 'src/assets/img/menu/icon_rin.png'
import IconManager from 'src/assets/img/menu/icon_manager.png'

import ProfileAsahi from 'src/assets/img/character/profile/profile_asahisoa.png'
import ProfileKazehaya from 'src/assets/img/character/profile/profile_kazehayasho.png'
import ProfileTachibana from 'src/assets/img/character/profile/profile_tachibanashun.png'
import ProfileWakatsuki from 'src/assets/img/character/profile/profile_wakatsukiren.png'
import ProfileYokohama from 'src/assets/img/character/profile/profile_yokohamaminato.png'

import RoomAsahi from 'src/assets/img/room/default_asahi_sora.png'
import RoomYokohama from 'src/assets/img/room/default_yokohama_minato.png'
import RoomWakatuki from 'src/assets/img/room/default_wakatuki_ren_update.png'
import RoomKazehaya from 'src/assets/img/room/default_kazehaya_sho.png'
import RoomTatibana from 'src/assets/img/room/default_tatibana_shun_update.png'
import MypageAsahi from 'src/assets/img/character/mypage/asahi_sora.png'
import MypageYokohama from 'src/assets/img/character/mypage/yokohama_minato.png'
import MypageWakatuki from 'src/assets/img/character/mypage/wakatuki_ren_update.png'
import MypageKazehaya from 'src/assets/img/character/mypage/kazehaya_sho.png'
import MypageTatibana from 'src/assets/img/character/mypage/tatibana_shun_update.png'

import voiceSora from 'src/assets/img/mypage/recommend/sora_voice.wav'
import voiceMinato from 'src/assets/img/mypage/recommend/minato_voice.wav'
import voiceSho from 'src/assets/img/mypage/recommend/sho_voice.wav'
import voiceSyun from 'src/assets/img/mypage/recommend/syun_voice.wav'
import voiceRen from 'src/assets/img/mypage/recommend/ren_voice.wav'
import voiceItsuki from 'src/assets/img/mypage/recommend/itsuki_voice.wav'
import voiceJin from 'src/assets/img/mypage/recommend/jin_voice.wav'
import voiceNagi from 'src/assets/img/mypage/recommend/nagi_voice.wav'
import voiceSakura from 'src/assets/img/mypage/recommend/sakura_voice.wav'
import voiceRin from 'src/assets/img/mypage/recommend/rin_voice.mp3'
import voiceRitsu from 'src/assets/img/mypage/recommend/ritsu_voice.mp3'
import voiceRei from 'src/assets/img/mypage/recommend/rei_voice.mp3'

import recommendSora from 'src/assets/img/mypage/recommend/bnr_sora.png'
import recommendSho from 'src/assets/img/mypage/recommend/bnr_sho.png'
import recommendKei from 'src/assets/img/mypage/recommend/bnr_kei.png'
import recommendSakura from 'src/assets/img/mypage/recommend/bnr_sakura.png'
import recommendJin from 'src/assets/img/mypage/recommend/bnr_jin.png'
import recommendNagi from 'src/assets/img/mypage/recommend/bnr_nagi.png'
import recommendItsuki from 'src/assets/img/mypage/recommend/bnr_itsuki.png'
import recommendSyun from 'src/assets/img/mypage/recommend/bnr_syun.png'
import recommendRen from 'src/assets/img/mypage/recommend/bnr_ren.png'
import recommendMinato from 'src/assets/img/mypage/recommend/bnr_minato.png'
import recommenRin from 'src/assets/img/mypage/recommend/bnr_rin.png'
import recommendRitsu from 'src/assets/img/mypage/recommend/bnr_ritsu.png'
import recommendRei from 'src/assets/img/mypage/recommend/bnr_rei.png'

import talentIconSora from 'src/assets/img/mypage/recommend/icon_sora.png'
import talentIconMinato from 'src/assets/img/mypage/recommend/icon_minato.png'
import talentIconSho from 'src/assets/img/mypage/recommend/icon_sho.png'
import talentIconSyun from 'src/assets/img/mypage/recommend/icon_syun.png'
import talentIconNagi from 'src/assets/img/mypage/recommend/icon_nagi.png'
import talentIconKei from 'src/assets/img/mypage/recommend/icon_kei.png'
import talentIconSakura from 'src/assets/img/mypage/recommend/icon_sakura.png'
import talentIconJin from 'src/assets/img/mypage/recommend/icon_jin.png'
import talentIconItsuki from 'src/assets/img/mypage/recommend/icon_itsuki.png'
import talentIconRen from 'src/assets/img/mypage/recommend/icon_ren.png'
import talentIconRin from 'src/assets/img/mypage/recommend/icon_rin.png'
import talentIconRitsu from 'src/assets/img/mypage/recommend/icon_ritsu.png'
import talentIconRei from 'src/assets/img/mypage/recommend/icon_rei.png'

import SoraActive from 'src/assets/img/voicealbum/sora_active.png'
import SoraDeactive from 'src/assets/img/voicealbum/sora_deactive.png'
import SoraDefault from 'src/assets/img/voicealbum/sora_default.png'
import MinatoActive from 'src/assets/img/voicealbum/minato_active.png'
import MinatoDeactive from 'src/assets/img/voicealbum/minato_deactive.png'
import MinatoDefault from 'src/assets/img/voicealbum/minato_default.png'
import RenActive from 'src/assets/img/voicealbum/ren_active.png'
import RenDeactive from 'src/assets/img/voicealbum/ren_deactive.png'
import RenDefault from 'src/assets/img/voicealbum/ren_default.png'
import ShoActive from 'src/assets/img/voicealbum/sho_active.png'
import ShoDeactive from 'src/assets/img/voicealbum/sho_deactive.png'
import ShoDefault from 'src/assets/img/voicealbum/sho_default.png'
import SyunActive from 'src/assets/img/voicealbum/syun_active.png'
import SyunDeactive from 'src/assets/img/voicealbum/syun_deactive.png'
import SyunDefault from 'src/assets/img/voicealbum/syun_default.png'
import SakuraActive from 'src/assets/img/voicealbum/sakura_active.png'
import SakuraDeactive from 'src/assets/img/voicealbum/sakura_deactive.png'
import SakuraDefault from 'src/assets/img/voicealbum/sakura_default.png'
import JinActive from 'src/assets/img/voicealbum/jin_active.png'
import JinDeactive from 'src/assets/img/voicealbum/jin_deactive.png'
import JinDefault from 'src/assets/img/voicealbum/jin_default.png'
import ItsukiActive from 'src/assets/img/voicealbum/itsuki_active.png'
import ItsukiDeactive from 'src/assets/img/voicealbum/itsuki_deactive.png'
import ItsukiDefault from 'src/assets/img/voicealbum/itsuki_default.png'
import NagiActive from 'src/assets/img/voicealbum/nagi_active.png'
import NagiDeactive from 'src/assets/img/voicealbum/nagi_deactive.png'
import NagiDefault from 'src/assets/img/voicealbum/nagi_default.png'
import RinActive from 'src/assets/img/voicealbum/rin_active.png'
import RinDeactive from 'src/assets/img/voicealbum/rin_deactive.png'
import RitsuActive from 'src/assets/img/voicealbum/ritsu_active.png'
import RinDefault from 'src/assets/img/voicealbum/rin_default.png'
import RitsuDefault from 'src/assets/img/voicealbum/ritsu_default.png'
import RitsuDeactive from 'src/assets/img/voicealbum/ritsu_deactive.png'
import ReiActive from 'src/assets/img/voicealbum/rei_active.png'
import ReiDeactive from 'src/assets/img/voicealbum/rei_deactive.png'
import ReiDefault from 'src/assets/img/voicealbum/rei_default.png'

import OfficialChannel from 'src/assets/img/menu/line_settings/official_channel.png'
import IconRealTimeChannel from 'src/assets/img/menu/line_settings/icon_real_time_channel.png'
import IconStoryTalkChannel from 'src/assets/img/menu/line_settings/icon_story_talk_channel.png'

export const characterNames = ['朝日空', '風早翔', '立花駿', '若槻蓮', '横浜湊']
export const CHARACTER_NAVIGATOR_ID = 6

// TODO: Add new characters and Image to this list.
export const CHARACTERS = [
  {
    name: '朝日空',
    avatar: IconSora,
    background: Background,
    id: 1,
    groupName: 'D6'
  },
  {
    name: '横浜湊',
    avatar: IconMinato,
    background: Background,
    id: 2,
    groupName: 'D6'
  },
  {
    name: '若槻蓮',
    avatar: IconRen,
    background: Background,
    id: 3,
    groupName: 'D6'
  },
  {
    name: '風早翔',
    avatar: IconSho,
    background: Background,
    id: 4,
    groupName: 'D6'
  },
  {
    name: '立花駿',
    avatar: IconSyun,
    background: Background,
    id: 5,
    groupName: 'D6'
  },
  {
    name: '彩音慶',
    background: Background,
    id: 7,
    groupName: 'solo',
    avatar: IconKei
  },
  {
    name: '九条咲良',
    background: Background,
    id: 8,
    groupName: '劇団J’s',
    avatar: IconSakura
  },
  {
    name: '来栖仁',
    background: Background,
    id: 9,
    avatar: IconJin,
    groupName: '劇団J’s'
  },
  {
    name: '折原樹',
    background: Background,
    id: 10,
    avatar: IconItsuki,
    groupName: '蒼生演舞'
  },
  {
    name: '飛鳥凪',
    background: Background,
    id: 11,
    avatar: IconNagi,
    groupName: '蒼生演舞'
  },
  {
    name: '九重燐',
    background: Background,
    id: 12,
    avatar: IconRin,
    groupName: 'links'
  },
  {
    name: '月城律',
    background: Background,
    id: 13,
    avatar: IconRitsu,
    groupName: 'links'
  },
  {
    name: '伊吹零',
    background: Background,
    id: 14,
    avatar: IconRei,
    groupName: 'links'
  }
]

export const LINE_SETTINGS = [
  {
    name: 'official channel',
    key: 'line_notifi',
    followKey: null,
    icon: OfficialChannel,
    link: process.env.REACT_APP_LINE_OFFICIAL_ACCOUNT_LINK
  },
  {
    name: 'story talk channel',
    followKey: 'line_follow_story',
    key: 'line_notify_story',
    icon: IconStoryTalkChannel,
    link: process.env.REACT_APP_LINE_STORY_LINK
  },
  {
    name: 'real time channel',
    followKey: 'line_follow_realtime',
    key: 'line_notify_realtime',
    icon: IconRealTimeChannel,
    link: process.env.REACT_APP_LINE_REALTIME_LINK
  }
]

export const CIRCLE_IMAGE_OF_CHARACTER = {
  1: IconSora,
  2: IconMinato,
  3: IconRen,
  4: IconSho,
  5: IconSyun,
  6: IconManager,
  7: IconKei,
  8: IconSakura,
  9: IconJin,
  10: IconItsuki,
  11: IconNagi,
  12: IconRin,
  13: IconRitsu,
  14: IconRei
}

export const CHARACTER_PROFILE_IMAGE = {
  1: ProfileAsahi,
  2: ProfileYokohama,
  3: ProfileWakatsuki,
  4: ProfileKazehaya,
  5: ProfileTachibana
}

export const MYPAGE_CHARACTER_IMAGES = {
  1: { image: MypageAsahi, room: RoomAsahi },
  2: { image: MypageYokohama, room: RoomYokohama },
  3: { image: MypageWakatuki, room: RoomWakatuki },
  4: { image: MypageKazehaya, room: RoomKazehaya },
  5: { image: MypageTatibana, room: RoomTatibana }
}

export const SCHEDULE_CHARACTER_IMAGES = {
  1: { name: '朝日空', color: 'bg-sora' },
  2: { name: '横浜湊', color: 'bg-minato' },
  3: { name: '若槻蓮', color: 'bg-ren' },
  4: { name: '風早翔', color: 'bg-sho' },
  5: { name: '立花駿', color: 'bg-syun' },
  7: { name: '彩音慶', color: 'bg-kei' },
  8: { name: '九条咲良', color: 'bg-sakura' },
  9: { name: '来栖仁', color: 'bg-jin' },
  10: { name: '折原樹', color: 'bg-itsuki' },
  11: { name: '飛鳥凪', color: 'bg-nagi' },
  12: { name: '九重燐', color: 'bg-rin' },
  13: { name: '月城律', color: 'bg-ritsu' },
  14: { name: '伊吹零', color: 'bg-rei' },
  1001: { name: 'Dx6', color: 'bg-dx6' },
  1005: { name: '来栖仁＆九条咲良', color: 'bg-theater-Js-background' },
  1008: { name: '飛鳥凪＆折原樹', color: 'bg-common-people-dance-background' },
  1010: { name: 'LINKS', color: 'bg-links' }
}

export const RECOMMEND_TALENT = [
  {
    id: 1,
    name: '朝日空',
    englishName: 'Sora Asahi',
    group: 'dx6',
    description: `君の笑顔が見たいから。
      いつでも君に
      エネルギーチャージ！
      D×6リーダー、朝日空`,
    age: '20',
    birthdate: '8月20日',
    bloodType: 'A',
    height: '176',
    zodiac: '獅子',
    fullImage: recommendSora,
    icon: talentIconSora,
    cv: '',
    voice: voiceSora
  },
  {
    id: 2,
    name: '横浜湊',
    group: 'dx6',
    englishName: 'Minato Yokohama',
    description:
      `満足するまで尽くして見せよう姫のため
      あなたの心に百花繚乱 横浜湊`,
    age: '20',
    birthdate: '6月23日',
    bloodType: 'B',
    height: '178',
    zodiac: '蟹子',
    fullImage: recommendMinato,
    icon: talentIconMinato,
    cv: '大城盛東',
    voice: voiceMinato
  },
  {
    id: 3,
    name: '若槻蓮',
    group: 'dx6',
    englishName: 'Ren Wakatsuki',
    description:
      `チャラくまじめに！生まれた時
      からモテ期が止まらない！
      ファンタジスタ★若槻蓮。`,
    age: '20',
    birthdate: '9月21日',
    bloodType: 'O',
    height: '175',
    zodiac: '乙女',
    fullImage: recommendRen,
    icon: talentIconRen,
    cv: '',
    voice: voiceRen
  },
  {
    id: 4,
    name: '風早翔',
    group: 'dx6',
    englishName: 'Sho Kazehaya',
    description:
      `シンデレラの君に。
      眠らずに見る夢を
      おもてなしの貴公子 風早翔`,
    age: '21',
    birthdate: '4月19日',
    bloodType: 'AB',
    height: '180',
    zodiac: '牡羊',
    fullImage: recommendSho,
    icon: talentIconSho,
    cv: '',
    voice: voiceSho
  },
  {
    id: 5,
    name: '立花駿',
    group: 'dx6',
    englishName: 'Syun Tachibana',
    description:
      `世界中の人を歌で笑顔に！
      顔面偏差値75♪
      D×6の天真爛漫 立花駿♪`,
    age: '20',
    birthdate: '11月22日',
    bloodType: 'O',
    height: '174',
    zodiac: 'さそり',
    fullImage: recommendSyun,
    icon: talentIconSyun,
    cv: '平畑栄樹',
    voice: voiceSyun
  },
  {
    id: 7,
    name: '彩音慶',
    group: 'solo',
    englishName: 'Kei Ayane',
    description:
      `響け、声。届け、想い。
      いつだって俺の声で、
      キミの心を満たしてあげる。`,
    age: '30',
    birthdate: '12月14日',
    bloodType: 'A',
    height: '176',
    zodiac: '射手',
    fullImage: recommendKei,
    icon: talentIconKei
  },
  {
    id: 8,
    name: '九条咲良',
    group: 'theater_groupej',
    englishName: 'Sakura Kujyo',
    description:
      `今日はキミと、
      最高のステージを。
      劇団J's、九条咲良`,
    age: '28',
    birthdate: '3月31日',
    bloodType: 'O',
    height: '178',
    job: '役者/演出家',
    fullImage: recommendSakura,
    icon: talentIconSakura,
    voice: voiceSakura
  },
  {
    id: 9,
    name: '来栖仁',
    group: 'theater_groupej',
    englishName: 'Jin Kurusu',
    description:
      `天下御免と参上致すは
      俺のこと。
      劇団J's、来栖仁だ。`,
    age: '28',
    birthdate: '7月26日',
    bloodType: 'A',
    height: '182',
    job: '役者/脚本家',
    fullImage: recommendJin,
    icon: talentIconJin,
    voice: voiceJin
  },
  {
    id: 10,
    name: '折原樹',
    group: 'aoi_dance',
    englishName: 'Itsuki Orihara',
    description:
      `ほら、顔をあげて？
      俺と花道を歩く心の準備、
      出来てるよね♪
      よそ見なんてさせない、
      ずっと俺達だけを見てなよ。`,
    age: '25',
    birthdate: '10月23日',
    bloodType: 'B',
    height: '180',
    job: 'ダンサー/舞台役者/脚本家',
    fullImage: recommendItsuki,
    icon: talentIconItsuki,
    voice: voiceItsuki
  },
  {
    id: 11,
    name: '飛鳥凪',
    group: 'aoi_dance',
    englishName: 'Nagi Asuka',
    description:
      `さぁ、俺の手を取って？
      凪兄さんが、キミが見た事の
      ない景色を見せてあげる♪`,
    age: '25',
    birthdate: '2月27日',
    bloodType: 'AB',
    height: '178',
    job: '役者ダンサー/舞台役者/脚本家',
    fullImage: recommendNagi,
    icon: talentIconNagi,
    voice: voiceNagi
  },
  {
    id: 12,
    name: '九重燐',
    group: 'links',
    englishName: 'Rin Kokonoe',
    description:
      `キミと俺で、世界でたった一つ
      のシンフォニアを奏でよう。
      LINKS九重燐`,
    age: '24',
    birthdate: '5月15日',
    bloodType: 'A',
    height: '177',
    zodiac: '牡牛',
    fullImage: recommenRin,
    icon: talentIconRin,
    voice: voiceRin
  },
  {
    id: 13,
    name: '月城律',
    group: 'links',
    englishName: 'Ritsu Tsukishiro',
    description:
      `退屈な日常から楽園へと、可愛
      い姫たちをトリップさせてあげ
      る♪LINKS月城律`,
    age: '24',
    birthdate: '2月10日',
    bloodType: 'A',
    height: '179',
    zodiac: 'みずがめ',
    fullImage: recommendRitsu,
    icon: talentIconRitsu,
    voice: voiceRitsu
  },
  {
    id: 14,
    name: '伊吹零',
    group: 'links',
    englishName: 'Rei Ibuki',
    description:
      `俺達に堕ちる覚悟はいい？俺以
      外の事なんて、見えなくさせて
      やる！LINKS伊吹零`,
    age: '23',
    birthdate: '11月11日',
    bloodType: 'O',
    height: '179',
    zodiac: 'さそり',
    fullImage: recommendRei,
    icon: talentIconRei,
    voice: voiceRei
  }
]

export const characterVoiceList = [
  { id: 1, name: 'sora', active: SoraActive, deactive: SoraDeactive, default: SoraDefault },
  { id: 2, name: 'minato', active: MinatoActive, deactive: MinatoDeactive, default: MinatoDefault },
  { id: 3, name: 'ren', active: RenActive, deactive: RenDeactive, default: RenDefault },
  { id: 4, name: 'sho', active: ShoActive, deactive: ShoDeactive, default: ShoDefault },
  { id: 5, name: 'syun', active: SyunActive, deactive: SyunDeactive, default: SyunDefault },
  { id: 6, name: 'chicken', active: null, deactive: null, default: null },
  { id: 7, name: 'kei', active: null, deactive: null, default: null },
  { id: 8, name: 'sakura', active: SakuraActive, deactive: SakuraDeactive, default: SakuraDefault },
  { id: 9, name: 'jin', active: JinActive, deactive: JinDeactive, default: JinDefault },
  { id: 10, name: 'itsuki', active: ItsukiActive, deactive: ItsukiDeactive, default: ItsukiDefault },
  { id: 11, name: 'nagi', active: NagiActive, deactive: NagiDeactive, default: NagiDefault },
  { id: 12, name: 'rin', active: RinActive, deactive: RinDeactive, default: RinDefault },
  { id: 13, name: 'ritsu', active: RitsuActive, deactive: RitsuDeactive, default: RitsuDefault },
  { id: 14, name: 'rei', active: ReiActive, deactive: ReiDeactive, default: ReiDefault }
]
